package sarka.design.skoria.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview
import sarka.design.skoria.presentation.LoginUiState
import sarka.design.skoria.ui.composables.SkoriaPrimaryButton
import sarka.design.skoria.ui.composables.SkoriaSecondaryButton
import sarka.design.skoria.ui.composables.SkoriaTextField
import sarka.design.skoria.ui.theme.RCTheme
import skoria.composeapp.generated.resources.Res
import skoria.composeapp.generated.resources.skoria_logo

@Composable
fun LoginScreen(
    state: LoginUiState,
    onUsernameChange: (String) -> Unit,
    onPasswordChange: (String) -> Unit,
    onLogin: () -> Unit,
    onLoginSuccess: () -> Unit,
    onLoginClick: () -> Unit,
    onRegisterClick: () -> Unit,
    onVerifyEmailClick: () -> Unit
) {
    LaunchedEffect(state.isLoggedIn) {
        if (state.isLoggedIn) {
            onLoginSuccess()
        }
    }

    Surface {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                painter = painterResource(Res.drawable.skoria_logo),
                contentDescription = "Skoria Logo",
                modifier = Modifier.size(120.dp)
            )

            Spacer(modifier = Modifier.height(16.dp))

            Text(
                text = "Skoria",
                color = RCTheme.colors.primary,
                fontSize = 32.sp
            )

            Spacer(modifier = Modifier.height(16.dp))

            SkoriaTextField(
                hint = "Username",
                value = state.username,
                onValueChange = onUsernameChange,
                enabled = !state.isLoading
            )

            Spacer(modifier = Modifier.height(16.dp))

            SkoriaTextField(
                hint = "Password",
                isPassword = true,
                value = state.password,
                onValueChange = onPasswordChange,
                enabled = !state.isLoading
            )

            if (state.error != null) {
                Spacer(modifier = Modifier.height(8.dp))
                Text(
                    text = state.error,
                    color = RCTheme.colors.error,
                    fontSize = 14.sp
                )
                
                if (state.needsEmailVerification) {
                    Spacer(modifier = Modifier.height(8.dp))
                    androidx.compose.material3.TextButton(onClick = onVerifyEmailClick) {
                        Text(
                            text = "Verify Email",
                            color = RCTheme.colors.primary,
                            fontSize = 14.sp
                        )
                    }
                }
            }

            Spacer(modifier = Modifier.height(32.dp))

            if (state.isLoading) {
                CircularProgressIndicator()
            } else {
                SkoriaPrimaryButton(
                    text = "Fake Login",
                    onClick = onLoginClick
                )

                SkoriaPrimaryButton(
                    text = "Login",
                    onClick = onLogin
                )

                SkoriaSecondaryButton(
                    text = "Register",
                    onClick = onRegisterClick
                )
            }
        }
    }
}

@Composable
@Preview
private fun LoginScreenPreview() {
    RCTheme {
        LoginScreen(
            state = LoginUiState(),
            onUsernameChange = {},
            onPasswordChange = {},
            onLogin = {},
            onLoginSuccess = {},
            onLoginClick = {},
            onRegisterClick = {},
            onVerifyEmailClick = {}
        )
    }
}
